
import { useState } from "react";
import { Box, Tab, Tabs, } from "@mui/material";
import { a11yProps, EstadoSolicitudExtranjero, sizeTab, } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import TableSolicitudExtranjero from "../shared/componente/TableSolicitudExtranjero";

export default function SolicitudVentaExtranejeroPage() {


  const [valueTab, setValueTab] = useState(0);
  return (
    <SingleTableBoxScene title={"Solicitud Venta Extranjeros"}
      py={2}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={'Pendiente'} {...a11yProps(0)} />
          <Tab label={'Aprobado'} {...a11yProps(0)} />
          <Tab label={'Fallido'} {...a11yProps(0)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TableSolicitudExtranjero />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <TableSolicitudExtranjero
          enableActions={false}
          estado_solicitud={EstadoSolicitudExtranjero.APROBADO}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <TableSolicitudExtranjero
          enableActions={false}
          estado_solicitud={EstadoSolicitudExtranjero.RECHAZADO}
        />
      </CustomTabPanel>

    </SingleTableBoxScene >
  );
}